import React, { Component } from "react";
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

/* for "axios" request cancelation */
import axios from 'axios';

/* Helpers */
import { history } from '../../../helpers/history';

/* Services */
import ParentService from "../../../services/parent.service";

/* Ant Design */
import { Typography, Card, Row, Col, Tag, Button, Image, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

/* for "axios" request cancelation check variable */
let source;

class PatientGames extends Component {
    constructor(props) {
        super(props);
        this.getUserGames = this.getUserGames.bind(this);
        this.downloadDesktopApp = this.downloadDesktopApp.bind(this);

        history.listen((location) => {
            props.parentDispatch.clearParent();
            props.gameDispatch.clearGames();
        });
    }

    componentDidMount() {
        /* Component Mount olurken source'a token iletilir */
        source = axios.CancelToken.source();

        this.props.parentDispatch.clearParent();
        this.props.gameDispatch.clearGames();

        this.getUserGames();
    }

    getUserGames() {
        this.props.gameDispatch.setLoading(true);

        ParentService.getParentGames(source.token)
            .then(
                (res) => {
                    this.props.gameDispatch.setGames(res.data);
                    this.props.gameDispatch.setLoading(false);
                },
                error => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    /* Request cancel edildiğinde message olarak 'Cancel' dönüyor. Hata bildirimi verilmesini engellemek için */
                    if (resMessage !== 'Cancel') {
                        toast.error(resMessage, { autoClose: 3000 });

                        this.clearTimer = setTimeout(() => {
                            this.props.history.push("/parent/store/games");
                        }, 3000);
                    }
                    this.props.gameDispatch.setLoading(false);
                }
            );
    }

    downloadDesktopApp() {
        window.location.href = process.env.REACT_APP_DESKTOPAPPLINK
    }

    componentWillUnmount() {
        /* Component Unmount edilirken cancel triggerı tetiklenir */
        if (source) {
            source.cancel();
        }

        clearTimeout(this.clearTimer);
    }

    render() {
        let gamesCount = 0;

        return (
            <div>
                <div>
                    <Typography.Title level={3} style={{ textAlign: 'center' }}>Sahip Olduğunuz Oyunlar</Typography.Title>
                    {/* Add Patient */}
                    <div>
                        <Button
                            className="AppDownloadButton"
                            type="primary"
                            size="large"
                            style={{ /* backgroundColor: '#237804', borderBlockColor: '#237804', */ float: 'right' }}
                            onClick={() => this.downloadDesktopApp()}
                            icon={<DownloadOutlined />}
                        >
                            Masaüstü Uygulamasını İndir
                        </Button>
                    </div>
                    <div style={{ clear: 'both' }}></div>
                    {!this.props.game.loading ?
                        <div>
                            {this.props.game.games &&
                                <div>
                                    <Typography.Title level={5} style={{ textAlign: 'start', marginTop: '1vh' }}><b>{this.props.game.games.length}</b> Adet Oyun Listelendi</Typography.Title>
                                    <div style={{ clear: 'both' }}></div>
                                </div>
                            }
                            <Row gutter={[32, 32]} style={{ marginTop: '2vh' }}>
                                {this.props.game.games &&
                                    (this.props.game.games.map(game => (
                                        <Col xs={24} md={12} lg={8} xl={6} xxl={4} key={game._id}>
                                            <Card
                                                size="small"
                                                cover={
                                                    <Image
                                                        preview={false}
                                                        width={'100%'}
                                                        src={game.PhotoLink}
                                                        alt={game.OyunAdi}
                                                        style={{ border: '1px solid #f0f0f0' }}
                                                        fallback="data:image/png;base64,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"
                                                    />
                                                }
                                                actions={[
                                                    <Button onClick={() => { this.props.history.push("/parent/games/" + game._id + "/detail"); }} style={{
                                                        width: '90%', backgroundColor: '#f0f5ff', borderRadius: "15px",
                                                        overflow: "hidden"
                                                    }} block>Detay...</Button>
                                                ]}
                                                style={((gamesCount + 1) % 2 === 0) ? {
                                                    backgroundColor: '#fafafa', borderRadius: "15px",
                                                    borderWidth: 2,
                                                    borderColor: '#fafafa',
                                                    boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)",
                                                    overflow: "hidden"
                                                } : {
                                                    backgroundColor: '#f0f0f0', borderRadius: "15px",
                                                    borderWidth: 2,
                                                    borderColor: '#f0f0f0',
                                                    boxShadow: "1px 2px 3px 1px rgba(208, 216, 243, 0.6)",
                                                    overflow: "hidden"
                                                }}
                                                loading={this.props.game.loading}
                                            >
                                                <Card.Meta
                                                    title={
                                                        <Typography.Title level={5}>
                                                            <Tooltip title={game.OyunAdi}>
                                                                {game.OyunAdi}
                                                            </Tooltip>
                                                        </Typography.Title>
                                                    }
                                                    description={game.OyunAciklama ? game.OyunAciklama : 'Oyun Açıklaması Bilgisine Ulaşılamadı!'}
                                                />
                                                <br />
                                                <p style={{ display: 'none' }}>{gamesCount += 1}</p>
                                                <Row gutter={[8, 12]} style={{ width: '100%' }}>
                                                    <Col span={24}>
                                                        <Tag
                                                            color="volcano"
                                                            style={{ whiteSpace: "normal", height: 'auto', marginBottom: '10px' }}
                                                        >
                                                            {game.KategoriID ? game.KategoriID.KategoriAdi : 'Kategori Bilgisine Ulaşılamadı!'}
                                                        </Tag>
                                                    </Col>
                                                    <Col span={24}>
                                                        <Tag
                                                            color="magenta"
                                                            style={{ whiteSpace: "normal", height: 'auto', marginBottom: '10px' }}
                                                        >
                                                            {game.EgzersizTipiID ? game.EgzersizTipiID.EgzersizTipiAdi : 'Egzersiz Tipi Bilgisine Ulaşılamadı!'}
                                                        </Tag>
                                                    </Col>
                                                    <Col span={24}>
                                                        {
                                                            game.Free === true ?
                                                                <Tag color="green">Ücretsiz</Tag>
                                                                :
                                                                <Tag color="red">Ücretli</Tag>
                                                        }
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                    )))}
                            </Row>
                        </div>
                        :
                        <Row gutter={[8, 32]} style={{ marginTop: '2vh' }}>
                            {Array(6).fill(1).map((el, i) =>
                                <Col xs={24} md={12} lg={8} xl={6} xxl={4} key={i}>
                                    <Card
                                        size="small"
                                        loading={this.props.game.loading}
                                    />
                                </Col>
                            )}
                        </Row>
                    }
                </div>
            </div >
        )
    }
}

const mapState = (state) => ({
    parent: state.parent,
    game: state.game,
});

const mapDispatch = (dispatch) => ({
    parentDispatch: dispatch.parent,
    gameDispatch: dispatch.game,
});

export default connect(mapState, mapDispatch)(PatientGames);